<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <title-edit header="Sponser program" />
    <line-hr />
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        &nbsp;
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <v-app class="switch-app">
          <v-switch label="Publish" v-model="form.is_publish"></v-switch>
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Orders* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.orders" @update="updateOrders" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Branch* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <select-option :items="optionBranch" :model="form.branch_id" @update="updateBranch" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Title TH* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.title_th" @update="updateTitleTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Title EN* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.title_en" @update="updateTitleEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Description TH* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-editor :model="form.description_th" @update="updateDescriptionTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Description EN* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-editor :model="form.description_en" @update="updateDescriptionEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Upload file* :</label>
      </v-col>
      <v-col cols="12" sm="9" xs="12">
        <v-row>
          <v-col cols="12" md="8">
            <input-upload-file :label="form.uploaded_file" @update="updateDownloadUrl" />
          </v-col>
          <v-col cols="12" md="2">
            <submit-button label="preview" @click.native="downloadUrl" />
          </v-col>
        </v-row>
      </v-col>
    </div>
    <line-hr />
    <command-button @delete-info="deleteSponserProgram" @save-info="saveSponserProgram"
      @save-close="saveClose"></command-button>
  </div>
</template>

<script>
import TitleEdit from "../../../components/TitleHeader/TitleEdit";
import LineHr from "../../../components/Icon/line-hr";
import SelectOption from "../../../components/Input/selectOption";
import DeleteButton from "../../../components/Button/DeleteButton";
import PreviewButton from "../../../components/Button/PreviewButton";
import SaveButton from "../../../components/Button/SaveButton";
import InputTextField from "../../../components/Input/InputTextField";
import InputEditor from "../../../components/Input/InputEditor";
import { mapState } from "vuex";
import { permissionSponserProgram, role } from "../../../util/Permission";
import Swal from "sweetalert";
import InputUploadFile from "../../../components/Input/InputUploadFile";
import SubmitButton from "../../../components/Button/SubmitButton";
import CommandButton from "../../../components/Layout/CommandButton";
import Loading from 'vue-loading-overlay';

export default {
  name: "SponserProgramEdit",
  components: {
    CommandButton,
    SubmitButton,
    InputUploadFile,
    InputEditor,
    InputTextField,
    SaveButton, PreviewButton, DeleteButton,
    SelectOption, LineHr, TitleEdit,
    Loading
  },
  computed: {
    permissionSponserProgram,
    ...mapState({
      form: state => {
        return state.SponserProgram.form;
      }
    })
  },
  data() {
    return {
      optionBranch: [],
      permission: null,
      save_id: null,
      isLoading: false,
    }
  },
  created() {
    this.permission = role;
    this.getBranchData();
  },
  methods: {
    getBranchData() {
      this.$store.dispatch("Branch/getBranchAll").then(res => {
        this.optionBranch = [
          { text: "Select", value: "" },
          ...res.filter(val => val.branch_id !== 0).map(type => ({
            value: type.branch_id,
            text: type.branch_name_th + " (" + type.branch_name_en + ")"
          }))
        ];
      });
    },
    saveClose() {
      this.$store.dispatch("SponserProgram/saveSponserProgram", {
        id: this.save_id ? this.save_id : this.form.id,
        data: this.form,
      }).then(res => {
        if (res.response_code == 200) {
          Swal(res.response_msg);
          this.goToSponserTable();
        }
      }).catch(() => {
        Swal('', 'Cannot save Sponser program data', 'error');
      })
    },
    saveSponserProgram() {
      this.isLoading = true
      this.$store.dispatch("SponserProgram/saveSponserProgram", {
        id: this.save_id ? this.save_id : this.form.id,
        data: this.form,
      }).then(res => {
        this.save_id = res.result.id;
        this.isLoading = false;
        Swal(res.response_msg);
      }).catch(() => {
        this.isLoading = false;
        Swal('', 'Cannot save Sponser program data', 'error');
      })
    },
    deleteSponserProgram() {
      this.$store.dispatch("SponserProgram/deleteSponserProgram", this.form.id).then(res => {
        if (res.response_code == 200) {
          this.goToSponserTable();
        }
      }).catch(() => {
        Swal('', 'Cannot delete Sponser program data', 'error');
      })
    },
    goToSponserTable() {
      this.$router.push("/about/sponser-program");
    },
    updateBranch(val) {
      this.form.branch_id = val;
    },
    updateTitleTH(val) {
      this.form.title_th = val;
    },
    updateTitleEN(val) {
      this.form.title_en = val;
    },
    updateDescriptionTH(val) {
      this.form.description_th = val;
    },
    updateDescriptionEN(val) {
      this.form.description_en = val;
    },
    updateOrders(val) {
      this.form.orders = val;
    },
    updateDownloadUrl(val) {
      this.form.uploaded_file = val.path;
      this.form.download_url_show = val.fullPath;
    },
    downloadUrl() {
      if (this.form.download_url_show) {
        window.open(this.form.download_url_show, "_blank");
      } else {
        Swal('', 'File not found for download', 'error');
      }
    },
  },
}
</script>

<style scoped></style>
